import React, { useRef, useState } from 'react'
import classes from './AddNote.module.css'
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
import { TbNotes } from 'react-icons/tb'
import { FiSend, FiX, FiUser } from 'react-icons/fi'
import { Popover, IconButton, Button } from '@mui/material'

const AddNote = (props) => {
    const [t] = useTranslation('common')
    const noteReasonRef = useRef()
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (event) => {
        if (event) event.stopPropagation()
        setAnchorEl(null)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        e.stopPropagation()
        props.onClick(noteReasonRef.current.value)
        noteReasonRef.current.value = ''
        handleClose()
    }

    const open = Boolean(anchorEl)

    // Styled popup window (shared by both variants)
    const notePopup = (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            slotProps={{
                paper: {
                    className: classes['note-container-styled'],
                    onClick: (e) => e.stopPropagation()
                }
            }}
        >
            <div className={classes['note-header']}>
                <div className={classes['note-header-title']}>
                    <TbNotes className={classes['note-header-icon']} />
                    <span>{t('Add Note to a forward')}</span>
                </div>
                <IconButton
                    size="small"
                    onClick={handleClose}
                    className={classes['close-btn']}
                >
                    <FiX />
                </IconButton>
            </div>
            {props.variant === 'button' && props.agentName && (
                <div className={classes['agent-info']}>
                    <span>{t('Transfer to')}: </span>
                    <div className={classes['agent-avatar-wrapper']}>
                        <img
                            src={props.avatarImg ? `${props.serverUrl}/users/${props.userId}/avatar` : props.defaultAvatar}
                            onError={(e) => e.target.src = props.defaultAvatar}
                            alt=""
                            className={classes['agent-avatar']}
                        />
                        <span className={`${classes['online-indicator']} ${props.isOnline ? classes['online'] : classes['offline']}`} />
                    </div>
                    <strong>{props.agentName}</strong>
                </div>
            )}
            <form onSubmit={submitHandler} className={classes['note-form']}>
                <div className={classes['note-reason-container']}>
                    <textarea
                        ref={noteReasonRef}
                        className={classes['note-textarea-styled']}
                        id='note-reason-textarea'
                        placeholder={t('Write your note here')}
                    />
                </div>
                <div className={classes['note-actions']}>
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        className={classes['cancel-btn']}
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        type='submit'
                        variant="contained"
                        className={classes['submit-btn']}
                        startIcon={<FiSend />}
                    >
                        {t('add')}
                    </Button>
                </div>
            </form>
        </Popover>
    )

    // Button variant - styled button for AgentList
    if (props.variant === 'button') {
        return (
            <div className="add-note-button-wrapper" onClick={(e) => e.stopPropagation()}>
                <div className={classes['styled-button']} onClick={handleClick}>
                    <TbNotes className={classes['styled-button-icon']} />
                    <span>{t('Note')}</span>
                </div>
                {notePopup}
            </div>
        )
    }

    // Default - original structure with Dropdown.Toggle for proper hover styling
    return (
        <Dropdown>
            <div onClick={(e) => { e.stopPropagation() }}>
                <Dropdown.Toggle
                    variant='outline-secondary'
                    className={`${classes['add-note-toggel']} ${props.toggleCss ? props.toggleCss : ''}`}
                    onClick={handleClick}
                >
                    <button className={`${classes['add-note']} ${props.btnCss ? props.btnCss : ''}`}>
                        {props.label && <span>{props.label}</span>}
                        <i className="fa-solid fa-comment-dots" />
                    </button>
                </Dropdown.Toggle>
            </div>
            {notePopup}
        </Dropdown>
    )
}

export default AddNote
